// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3qLd3","vLegacy":"SelectSecondary_vLegacy__3BqBW","error":"SelectSecondary_error__3kDFx","disabled":"SelectSecondary_disabled__2ddfu"};